import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar implements OnInit {
  isCollapsed = false;
  isDarkMode = false;

  ngOnInit() {
    if (typeof window !== 'undefined' && window.innerWidth <= 992) {
      this.isCollapsed = true;
    }
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  toggleTheme() {
    document.body.classList.toggle('dark-mode');
    this.isDarkMode = !this.isDarkMode;
  }

  isMobileMenuOpen = false;

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  menuItems = [
    { icon: 'assets/images/bank1.svg', label: 'Dashboard', route: '/dashboard' },
    { icon: 'assets/images/transfer.svg', label: 'Transactions', route: '/transactions' },
    { icon: 'assets/images/pie-chart.svg', label: 'My Accounts', route: '/accounts' },
    { icon: 'assets/images/card.svg', label: 'Pay Bills', route: '/bills' },
    { icon: 'assets/images/money.svg', label: 'Transfer Funds', route: '/transfer' },
    { icon: 'assets/images/briefcase.svg', label: 'Investments', route: '/investments' }
  ];

  bottomActions = [
    { icon: 'assets/images/support.svg', label: 'Support', isAvatar: false, route: '/support' },
    { icon: 'assets/images/user.png', label: 'Ledenov M.', isAvatar: true, route: '/settings' },
    { icon: 'assets/images/settings.svg', label: 'Settings', isAvatar: false, route: '/settings' }
  ];
}
